import moment from 'moment';
import Vue from 'vue';
declare var SC_LANG: any;

Vue.filter('formatAsDate', (value: string) => {
    if (value) {
        moment.locale(SC_LANG); // todo: hack/fix for corret locale
        return moment(new Date(value)).format('LL');
    }
});

Vue.filter('formatDate', (value: Date) => {
    if (value) {
        moment.locale(SC_LANG); // todo: hack/fix for corret locale
        return moment(value).format('LL');
    }
});
